import {RotatingLines} from "react-loader-spinner";
import basestyle from "../../Pages/Base.module.css";
import FailedRowsErrModal from "../Modal/FailedRowsErr";
import Dialog from "../Modal/Dialog";
import { LOCALIZATION_EN } from "../../Constants/constants";

const BulkUploadErrorModal = ({isLoading,successRows,failedRows,closeModal}) => {
    return (
        <Dialog>
            <div className="dashboard-upload-modal-container">
                {isLoading && (
                    <>
                        <div className="dashboard-upload-modal-text">
                            <h2>{LOCALIZATION_EN.csvFileBeingUploaded}</h2>
                        </div>
                        <RotatingLines
                            strokeColor="grey"
                            strokeWidth="5"
                            animationDuration="1"
                            width="80"
                            visible={true}
                        />
                    </>
                )}
                <div className="dashboard-upload-modal-uploaded-text">
                    {successRows?.length && !failedRows?.length  && !isLoading && (
                        <h2>{LOCALIZATION_EN.csvUploadedSuccessfully}</h2>
                    )}
                </div>
                {!failedRows && !successRows && !isLoading && (
                    <div className="dashboard-upload-modal-err-message">
                        <h2>{LOCALIZATION_EN.somthingWentWrong}</h2>
                    </div>
                )}
                {!isLoading && (
                    <button
                        name="submit-btn"
                        className={basestyle.button_modal}
                        onClick={closeModal}
                    >
                        {LOCALIZATION_EN.close}
                    </button>
                )}
            </div>
            {failedRows?.length && (
                <FailedRowsErrModal
                    successRows={successRows}
                    failedRows={failedRows}
                    onClose={closeModal}
                />
            )}
        </Dialog>
    )
}

export default  BulkUploadErrorModal;